import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useContext } from 'react';
import { NavLink } from "react-router-dom";
import { AuthContext } from "../session/AuthProvider";
import NavItem from "./NavItem";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import { routes } from "../routes/routes";
import * as stylex from "@stylexjs/stylex";
import { permissionUtil } from "src/session/permissionUtil";
import CloudinaryImg from "nood-comp/src/comp/ui/image-viewer/CloudinaryImg";
import LogoSvg from "nood-comp/src/common/LogoSvg";
export default function AdminNav(props) {
  var _auth$user;
  var auth = useContext(AuthContext);
  var user = auth === null || auth === void 0 ? void 0 : auth.user;
  var permissions = user === null || user === void 0 ? void 0 : user.permissions;
  if (user === void 0 || user === null || permissions === void 0 || permissions === null) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement("div", {
    className: "AdminNav__ui.base ev11ycvst evixxii4 evhtitgo ev15cnf4b ev1kmh6xq ev1sigipf evdf1pr7 evmlui4w ev3v9q2z ev1mujto1 ev1xoudmy evkhjacq ev1vu5nja ev1x8x6xe evk12dgq ev1drl03n"
  }, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 10
  }), /*#__PURE__*/React.createElement(NavLink, _extends({
    to: "/"
  }, {
    className: "AdminNav__ui.logo evmtwg9"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(LogoSvg, {
    size: 45,
    accent: "#d7760f"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), permissionUtil.has({
    permissions: permissions,
    entities: ['events']
  }) && /*#__PURE__*/React.createElement(NavItem, {
    to: routes.event,
    icon: 'calendar',
    caption: 'Events'
  }), permissionUtil.has({
    permissions: permissions,
    entities: ['org', 'orgs', 'campus', 'campuses', 'system', 'systems']
  }) && /*#__PURE__*/React.createElement(NavItem, {
    to: '/orgs',
    icon: 'organization',
    caption: 'Orgs'
  }), permissionUtil.has({
    permissions: permissions,
    entities: ['adminusers', 'planparams', 'files']
  }) && /*#__PURE__*/React.createElement(NavItem, {
    to: '/admin',
    icon: 'user',
    caption: 'Admin'
  }), /*#__PURE__*/React.createElement(NavItem, {
    to: '/app',
    icon: 'grid',
    caption: 'App'
  }), /*#__PURE__*/React.createElement("div", {
    className: "AdminNav__ui.me_container ev1pd2b8k ev1f4nc6d evhu9fad ev12piwxp ev1wfyaev evy1ia1s ev1rq507w ev1b8njcv ev1208exr evm1edtm ev17o4bw evle4ggd"
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: '/me'
  }, /*#__PURE__*/React.createElement(CloudinaryImg, {
    filename: auth === null || auth === void 0 || (_auth$user = auth.user) === null || _auth$user === void 0 || (_auth$user = _auth$user.img) === null || _auth$user === void 0 ? void 0 : _auth$user.filename,
    resourceImageSize: 'S',
    stylex: [ui.me_img],
    style: {
      borderRadius: undefined,
      border: "1px solid var(--shade-10)"
    }
  }))));
}

// @ts-ignore
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".evixxii4{position:fixed}", 3000);
_inject(".evhtitgo{z-index:2}", 3000);
_inject(".ev15cnf4b{transition:width .3s}", 2000);
_inject("@media(min-width:501px){.ev1kmh6xq.ev1kmh6xq{top:0}}", 4200);
_inject("@media(min-width:501px){.ev1sigipf.ev1sigipf{width:70px}}", 4200);
_inject("@media(min-width:501px){.evdf1pr7.evdf1pr7{left:0}}", 4200);
_inject("@media(min-width:501px){.evmlui4w.evmlui4w{bottom:0}}", 4200);
_inject("@media(min-width:501px){.ev3v9q2z.ev3v9q2z{padding:5px}}", 1200);
_inject("@media(min-width:501px){.ev1mujto1.ev1mujto1{border-right:1px solid var(--shade-10)}}", 2200);
_inject("@media (max-width: 500px){.ev1xoudmy.ev1xoudmy{left:0}}", 4200);
_inject("@media (max-width: 500px){.evkhjacq.evkhjacq{right:0}}", 4200);
_inject("@media (max-width: 500px){.ev1vu5nja.ev1vu5nja{bottom:0}}", 4200);
_inject("@media (max-width: 500px){.ev1x8x6xe.ev1x8x6xe{height:65px}}", 4200);
_inject("@media (max-width: 500px){.evk12dgq.evk12dgq{display:flex}}", 3200);
_inject("@media (max-width: 500px){.ev1drl03n.ev1drl03n{border-top:1px solid var(--shade-10)}}", 2200);
_inject("@media (max-width:500px){.evmtwg9.evmtwg9{display:none}}", 3200);
_inject("@media(min-width:501px){.ev1pd2b8k.ev1pd2b8k{display:flex}}", 3200);
_inject("@media(min-width:501px){.ev1f4nc6d.ev1f4nc6d{align-items:center}}", 3200);
_inject("@media(min-width:501px){.evhu9fad.evhu9fad{justify-content:center}}", 3200);
_inject("@media(min-width:501px){.ev12piwxp.ev12piwxp{bottom:15px}}", 4200);
_inject("@media(min-width:501px){.ev1wfyaev.ev1wfyaev{position:absolute}}", 3200);
_inject("@media(min-width:501px){.evy1ia1s.evy1ia1s{border:0 solid red}}", 1200);
_inject("@media(min-width:501px){.ev1rq507w.ev1rq507w{width:100%}}", 4200);
_inject("@media(min-width:501px){.ev1b8njcv.ev1b8njcv{margin-left:-7px}}", 4200);
_inject("@media(max-width:500px){.ev1208exr.ev1208exr{flex:1}}", 2200);
_inject("@media(max-width:500px){.evm1edtm.evm1edtm{display:flex}}", 3200);
_inject("@media(max-width:500px){.ev17o4bw.ev17o4bw{align-items:center}}", 3200);
_inject("@media(max-width:500px){.evle4ggd.evle4ggd{justify-content:center}}", 3200);
_inject("@media(min-width:501px){.evtu9jzk.evtu9jzk{width:40px}}", 4200);
_inject("@media(min-width:501px){.ev1plq7ks.ev1plq7ks{height:40px}}", 4200);
_inject("@media(min-width:501px){.ev7dr4nq.ev7dr4nq{border-radius:40px}}", 2200);
_inject("@media(max-width:500px){.evrh9tz8.evrh9tz8{width:30px}}", 4200);
_inject("@media(max-width:500px){.ev1mybsiy.ev1mybsiy{height:30px}}", 4200);
_inject("@media(max-width:500px){.ev17ayjw1.ev17ayjw1{border-radius:30px}}", 2200);
var ui = {
  me_img: {
    "AdminNav__ui.me_img": "AdminNav__ui.me_img",
    "@media(min-width:501px)_width": "evtu9jzk",
    "@media(min-width:501px)_height": "ev1plq7ks",
    "@media(min-width:501px)_borderRadius": "ev7dr4nq",
    "@media(min-width:501px)_borderStartStartRadius": null,
    "@media(min-width:501px)_borderStartEndRadius": null,
    "@media(min-width:501px)_borderEndStartRadius": null,
    "@media(min-width:501px)_borderEndEndRadius": null,
    "@media(min-width:501px)_borderTopLeftRadius": null,
    "@media(min-width:501px)_borderTopRightRadius": null,
    "@media(min-width:501px)_borderBottomLeftRadius": null,
    "@media(min-width:501px)_borderBottomRightRadius": null,
    "@media(max-width:500px)_width": "evrh9tz8",
    "@media(max-width:500px)_height": "ev1mybsiy",
    "@media(max-width:500px)_borderRadius": "ev17ayjw1",
    "@media(max-width:500px)_borderStartStartRadius": null,
    "@media(max-width:500px)_borderStartEndRadius": null,
    "@media(max-width:500px)_borderEndStartRadius": null,
    "@media(max-width:500px)_borderEndEndRadius": null,
    "@media(max-width:500px)_borderTopLeftRadius": null,
    "@media(max-width:500px)_borderTopRightRadius": null,
    "@media(max-width:500px)_borderBottomLeftRadius": null,
    "@media(max-width:500px)_borderBottomRightRadius": null,
    "@media(max-width:500px)_display": "evm1edtm",
    "@media(max-width:500px)_alignItems": "ev17o4bw",
    "@media(max-width:500px)_justifyContent": "evle4ggd",
    $$css: true
  }
};